/**
 * 认证相关工具函数
 */

/**
 * 检查用户是否已认证
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  return token !== null && user !== null;
};

/**
 * 获取当前用户信息
 */
export const getCurrentUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('解析用户信息失败:', error);
    return null;
  }
};

/**
 * 安全的页面跳转
 * 确保认证状态正确后再跳转
 */
export const safeNavigate = (navigate, path, options = {}) => {
  // 检查认证状态
  if (!isAuthenticated()) {
    console.warn('用户未认证，跳转到登录页');
    navigate('/login', { replace: true });
    return;
  }

  // 延迟跳转确保状态同步
  setTimeout(() => {
    navigate(path, { replace: true, ...options });
  }, 100);
};

/**
 * 验证登录状态并等待token保存完成
 * @param {number} maxRetries 最大重试次数
 * @param {number} retryDelay 重试间隔（毫秒）
 * @returns {Promise<boolean>} 是否验证成功
 */
export const waitForAuthComplete = (maxRetries = 5, retryDelay = 100) => {
  return new Promise((resolve) => {
    let retries = 0;

    const checkAuth = () => {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');

      if (token && user) {
        console.log('认证验证成功');
        resolve(true);
        return;
      }

      retries++;
      if (retries >= maxRetries) {
        console.warn('认证验证超时');
        resolve(false);
        return;
      }

      console.log(`认证验证重试 ${retries}/${maxRetries}`);
      setTimeout(checkAuth, retryDelay);
    };

    checkAuth();
  });
};

/**
 * 安全的登录后跳转
 * 确保token保存完成后再跳转
 */
export const safeLoginRedirect = async (targetPath = '/dashboard', navigateFn) => {
  const authComplete = await waitForAuthComplete();

  if (authComplete) {
    if (typeof navigateFn === 'function') {
      navigateFn(targetPath, { replace: true });
    } else {
      window.location.replace(targetPath);
    }
    return;
  }

  localStorage.removeItem('token');
  localStorage.removeItem('user');
  throw new Error('登录状态验证失败');
};

/**
 * 强制跳转（用于登录成功后）
 */
export const forceNavigate = (path, navigateFn) => {
  if (typeof navigateFn === 'function') {
    navigateFn(path, { replace: true });
    return;
  }
  window.location.replace(path);
};
